import _ from 'lodash';
import globalStore from '$$globalStore';
import resourcesOverload from '../../../components/resourcesOverload';

export default function (instance, ganttData) {
  instance.ganttDataApi.getResourceById = resourceId => {
    if (!ganttData) {
      return globalStore.getters['resourcesModel/getResourceById'](resourceId);
    }

    return ganttData.allResources?.find(o => o.id === +resourceId);
  };

  instance.ganttDataApi.getResourceByUserId = userId => {
    if (!ganttData) {
      return globalStore.getters['resourcesModel/getResourceByUserId'](userId);
    }

    return ganttData.allResources?.find(o => o.userId === +userId);
  };

  instance.ganttDataApi.getResourcesByProjectIdsAndType = (projectIds, type) => {
    if (!ganttData) {
      return globalStore.getters['resourcesModel/getResourcesByProjectIdsAndType'](projectIds, type);
    }

    return ganttData.allResources?.filter(resourceData => resourceData.resourceProjects.find(o => projectIds.includes(o.projectId) && o.type === type)) || [];
  };

  instance.ganttDataApi.getResourcesByTaskIdAndGanttId = (projectId, taskId) => {
    if (!ganttData) {
      return globalStore.getters['resourcesModel/getResourcesByTaskIdAndGanttId'](projectId, taskId);
    }

    const taskResources = ganttData.projectTasksData?.resourcesToTasks?.[taskId];
    const projectResources = ganttData.allResources?.filter(resourceData => resourceData.resourceProjects.find(o => o.projectId === +projectId));

    if (!taskResources || !projectResources) {
      return [];
    }

    const groupByResourceId = _.groupBy(projectResources, 'id');
    const result = [];

    taskResources.length && taskResources.forEach(taskResource => {
      const resourceData = groupByResourceId[taskResource.resource_id];

      if (resourceData) {
        result.push(...resourceData);
      }
    });

    return result;
  };

  instance.ganttDataApi.getResourcesByProjectIdForUI = projectId => {
    const allResources = ganttData ? ganttData.allResources : globalStore.getters['resourcesModel/getAllResources'];
    const preparedResources = [];

    allResources?.forEach(resourceData => {
      const resourceProjectData = resourceData.resourceProjects.find(o => o.projectId === +projectId);

      if (resourceProjectData) {
        preparedResources.push({
          id: resourceData.id,
          userId: resourceData.userId,
          name: resourceData.name,
          value: resourceData.name,
          type: resourceProjectData.type,
          price: resourceProjectData.price,
          picture: resourceData.photo || (`${GT.cdn}/imgs/default/default-ava.svg`),
        });
      }
    });

    return _.sortBy(preparedResources, resource => resource.name.toLowerCase());
  };

  instance.ganttDataApi.getOverloadedResources = options => {
    if (!ganttData) {
      return resourcesOverload.getOverloadedResources(options);
    }

    return null;
  };
}
